import { Save } from "@mui/icons-material";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLoading } from "../../../../components/Loading/useLoading";
import { GetAllPartesList } from "../../../../hooks/getPartesList";
import { GetAllClientesList } from "../../../../hooks/getListClientes";
import { UpdatePrioridad } from "../../../../hooks/planProductivo";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
  maxHeight: "80vh",
  overflowY: "scroll",
};

export const ModalEditItems = ({
  open,
  handleClose,
  items,
  almaSelected,
  maxRacks,
}) => {
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { updatePrioridadMutation } = UpdatePrioridad();
  const { getAllPartesListMutation } = GetAllPartesList();
  const { getAllClientesListMutation } = GetAllClientesList();
  const [partes, setPartes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [distributionConfig, setDistributionConfig] = useState([]);

  useEffect(() => {
    getClientes();
    getPartes();
  }, []);
  useEffect(() => {
    if (items && open) {
      setDistributionConfig(items);
    }
  }, [items, open]);

  const handleSave = () => {
    const body = distributionConfig.map((item) => ({
      pp_alma_item_id: item.pp_alma_item_id,
      emp_id: item.emp_id,
      part_id: item.part_id,
      pp_alma_item_racks: item.pp_alma_item_racks,
    }));
    console.log("Body a enviar:", body);
    setAppLoading(true)
    updatePrioridadMutation(body, {
      onSuccess: () => {
        enqueueSnackbar("Se actualizaron los items correctamente", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: () => {
        enqueueSnackbar("Error al editar items", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        handleClose();
      }
    })
  };

  const handleChangeDistribution = (value, name, index) => {
    console.log(value, name, index);
    let distribution = [...distributionConfig];
    if (name === "emp_id") {
      distribution[index]["part_id"] = null;
      distribution[index][name] = value;
    } else if (name === "pp_alma_item_racks") {
      if (value === null) {
        distribution[index][name] = null;
      } else {
        let totalRacks = distribution.reduce((total, dist, index) => {
          return total + (+dist.pp_alma_item_racks || 0);
        }, 0);
        console.log(
          "Total racks actual:",
          totalRacks,
          maxRacks,
          +distribution[index][name],
        );
        totalRacks = totalRacks - (+distribution[index][name] || 0);
        const newTotalRacks = totalRacks + (+value || 0);
        if (newTotalRacks > maxRacks) {
          console.log(totalRacks);
          distribution[index][name] = maxRacks - totalRacks;
          enqueueSnackbar(
            "La cantidad de racks excede el límite permitido para esta línea, favor de verificar",
            {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            },
          );
        } else {
          distribution[index][name] = value;
        }
      }
    } else {
      distribution[index][name] = value;
    }
    setDistributionConfig(distribution);
  };
  const getClientes = () => {
    getAllClientesListMutation(
      {},
      {
        onSuccess: (data) => {
          data.sort((a, b) => {
            return a.label.localeCompare(b.label);
          });
          setClientes(data);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  };
  const getPartes = () => {
    setAppLoading(true);
    getAllPartesListMutation(
      {},
      {
        onSuccess: (data) => {
          setPartes(data);
        },
        onError: (error) => {
          console.log(error);
        },
        onSettled: () => {
          setAppLoading(false);
        },
      },
    );
  };
  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              className="center_item"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Typography component="span">Editar Item</Typography>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  onClick={() => handleSave()}
                  endIcon={<Save />}
                  sx={{
                    background: "#575E3B",
                    borderRadius: 2,
                    px: 4,
                    py: 1.2,
                    fontWeight: 700,
                    fontSize: 14,
                    textTransform: "none",
                    boxShadow: `0 4px 14px #575E3B44`,
                    "&:hover": {
                      background: "#40442d",
                      boxShadow: `0 6px 18px #575E3B55`,
                    },
                  }}
                >
                  Guardar
                </Button>
              </div>
            </Grid>
            {items.map((item, index) => (
              <Grid item xs={12} className="center_item">
                <Grid container spacing={0}>
                  <Grid item xs={2} className="center_item" sx={{ p: 1 }}>
                    <TextField
                      id="pp_alma_item_racks"
                      label="Racks"
                      name="pp_alma_item_racks"
                      fullWidth
                      size="small"
                      value={item.pp_alma_item_racks}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "") {
                          handleChangeDistribution(
                            null,
                            "pp_alma_item_racks",
                            index,
                          );
                        } else {
                          handleChangeDistribution(
                            Number(value),
                            "pp_alma_item_racks",
                            index,
                          );
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                    <Autocomplete
                      fullWidth
                      id="emp_id"
                      getOptionLabel={(opcion) => opcion.label}
                      filterSelectedOptions
                      options={clientes}
                      onKeyDown={handleKeyUp}
                      defaultValue={
                        clientes.find(
                          (cliente) => cliente.value === item.emp_id,
                        ) || null
                      }
                      onChange={(e, newValue) =>
                        handleChangeDistribution(
                          newValue?.value || null,
                          "emp_id",
                          index,
                        )
                      }
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>
                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cliente"
                          size="small"
                          fullWidth
                          required
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                    <Autocomplete
                      fullWidth
                      id="part_id"
                      getOptionLabel={(opcion) =>
                        opcion?.codigo !== undefined
                          ? `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}`
                          : opcion?.label
                      }
                      filterSelectedOptions
                      options={partes.filter(
                        (part) => part.emp_id === item.emp_id,
                      )}
                      value={
                        partes.find((parte) => parte.value === item.part_id) ||
                        null
                      }
                      disabled={!item.emp_id}
                      onKeyDown={handleKeyUp}
                      onChange={(e, newValue) =>
                        handleChangeDistribution(
                          newValue?.value || null,
                          "part_id",
                          index,
                        )
                      }
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>
                          {option?.codigo !== undefined ? (
                            option?.codigo
                          ) : (
                            <></>
                          )}{" "}
                          /
                          {option?.codigo_salida !== undefined ? (
                            option?.codigo_salida
                          ) : (
                            <></>
                          )}{" "}
                          /
                          {option?.codigo_alterno !== undefined ? (
                            option?.codigo_alterno
                          ) : (
                            <></>
                          )}{" "}
                          / {option?.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Parte"
                          size="small"
                          fullWidth
                          required
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
